module.exports = __webpack_public_path__ + "img/img1.ef89454d.png";